export default import.meta.ROLLDOWN_FILE_URL_nnHd5xFZXImkhSjNC3eMGg